// dependencies
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useArray } from "react-hanger";
import { format, isAfter, isValid } from "date-fns";
import { GenerateProcess } from "redux-process";
import React, { useEffect, useState } from "react";

// components
import Button from "Components/Button";
import ErrorBoundary from "Components/ErrorBoundary";

// actions

// selectors
import { getSelectedUserID } from "../../selectors";

// css
import css from "./UpcomingNotifications.styl";

const Notification = (props) => {
	const { notification, openNotifications, toggleNotificationData } = props;

	const id = notification._id;
	const name = notification.notification_name;
	const isOpen = openNotifications.value.indexOf(id) >= 0;

	const notAfter = notification.not_after;
	const notBefore = notification.not_before;

	const notAfterDate = isValid(notAfter) ? format(notAfter, "MMM d, yyyy h:mm a") : "Invalid Date";
	const notBeforeDate = isValid(notBefore) ? format(notBefore, "MMM d, yyyy h:mm a") : "Invalid Date";

	const isNotReadyYet = isValid(notBefore) ? isAfter(notBefore, new Date()) : false;
	const isExpired = isValid(notAfter) ? isAfter(new Date(), notAfter) : false;

	const isValidNotification = !isExpired && !isNotReadyYet;

	return (
		<div className={`${css.notificationItem} ${isValidNotification ? css.isValidNotification : ""}`} key={id}>
			<div className={css.notificationContent}>
				<div className={css.dotContainer}>
					<div className={css.dot} />
				</div>
				<div className={css.notificationName}>{name}</div>
				<div className={`${css.notificationDate} ${isNotReadyYet ? css.isInvalid : ""}`}>{notBeforeDate}</div>
				<div className={`${css.notificationDate} ${isExpired ? css.isInvalid : ""}`}>{notAfterDate}</div>
				<div>
					<Button className={`${css.viewButton}`} onClick={() => toggleNotificationData(id)}>
						View
					</Button>
				</div>
			</div>

			{isOpen ? (
				<div className={css.notificationData}>
					<div>{JSON.stringify(notification, null, 2)}</div>
				</div>
			) : null}
		</div>
	);
};

const UpcomingNotifications = (props) => {
	const { type, userID } = props;

	const openNotifications = useArray([]);
	const [notificationTypes, setNotificationTypes] = useState([]);
	const [notificationItems, setNotificationItems] = useState([]);

	useEffect(() => {
		const init = async () => {
			const request = await props.fetchUpcomingNotifications(userID, type);

			if (request.succeeded) {
				// sort by the 'not before' date
				const notifications = request.response.notifications.sort((a, b) => a.not_before - b.not_before);

				const notificationNames = request.response.userSettings.notificationNames
					? request.response.userSettings.notificationNames
					: [];

				setNotificationItems(notifications);
				setNotificationTypes(notificationNames);
			}
		};

		init();
	}, []);

	const toggleNotificationData = (notificationID) => {
		const currentIndex = openNotifications.value.indexOf(notificationID);

		if (currentIndex >= 0) {
			openNotifications.removeIndex(currentIndex);
		} else {
			openNotifications.push(notificationID);
		}
	};

	return (
		<div>
			<div className={css.notifications}>
				<div className={css.title}>
					<span>Upcoming Notifications</span>
				</div>

				<div className={css.tableHead}>
					<div />
					<div>Notification</div>
					<div>Not Before</div>
					<div>Not After</div>
					<div />
				</div>

				<div className={css.content}>
					{notificationItems.map((notification) => {
						const key = notification._id;

						return (
							<ErrorBoundary key={key}>
								<Notification
									notification={notification}
									openNotifications={openNotifications}
									toggleNotificationData={toggleNotificationData}
								/>
							</ErrorBoundary>
						);
					})}
				</div>
			</div>

			<div className={css.notificationTypes}>
				<div className={css.title}>
					<span>Notification Types</span>
				</div>

				<div className={css.content}>
					{notificationTypes.sort().map((notificationType) => (
						<div key={notificationType} className={css.notificationType}>
							<div className={css.highlight}>{notificationType}</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

UpcomingNotifications.propTypes = {
	fetchUpcomingNotifications: PropTypes.func.isRequired,
	userID: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
	userID: getSelectedUserID(state),
});

const mapDispatchToProps = (dispatch) => ({
	fetchUpcomingNotifications: (userID, type) =>
		dispatch(GenerateProcess("fetchUpcomingNotifications", { userID, type })),
});

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingNotifications);
